
/**
 * BGF Shop Page Fixes
 * - Removes broken "Notify Me" forms from coming soon panels
 * - Replaces with a simple "Coming Soon" message pointing to newsletter
 */
(function() {
  'use strict';

  function fixNotifyForms() {
    var panels = ['bgf-empty-pet-snacks', 'bgf-empty-garden'];
    panels.forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      
      // Find and remove the form
      var form = el.querySelector('form');
      if (form) {
        var note = document.createElement('p');
        note.style.marginTop = '1em';
        note.style.fontStyle = 'italic';
        note.style.opacity = '0.7';
        note.style.fontSize = '0.9em';
        note.textContent = 'Sign up for our newsletter below to be notified when these products launch.';
        form.parentNode.replaceChild(note, form);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixNotifyForms);
  } else {
    fixNotifyForms();
  }
})();
